import React from "react";
import ReactDOM from "react-dom";
import SecuredAppWrapper from "./SecuredAppWrapper";
import "antd/dist/antd.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./fonts/Montserrat/Montserrat-Regular.ttf";
import "./fonts/OpenSans/OpenSans-Regular.ttf";

ReactDOM.render(
  <React.StrictMode>
    <SecuredAppWrapper className="root" />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
